// Simple token-based auth using localStorage.
// Works across iframes, iPad Safari, incognito — anywhere cookies don't.
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Still useful as fallback where cookies DO work
axios.defaults.withCredentials = true;

const TOKEN_KEY = 'fmaa_access_token';
const REFRESH_KEY = 'fmaa_refresh_token';

export const authStorage = {
  getToken: () => localStorage.getItem(TOKEN_KEY),
  getRefresh: () => localStorage.getItem(REFRESH_KEY),
  setTokens: (access, refresh) => {
    if (access) localStorage.setItem(TOKEN_KEY, access);
    if (refresh) localStorage.setItem(REFRESH_KEY, refresh);
  },
  clear: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_KEY);
  },
};

// Attach Authorization header to every request if we have a token
axios.interceptors.request.use((config) => {
  const t = authStorage.getToken();
  if (t && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

// Auto-clear on 401 (except for the login/register/me boot calls themselves)
axios.interceptors.response.use(
  (r) => r,
  (error) => {
    const url = error?.config?.url || '';
    if (error?.response?.status === 401 && !url.includes('/auth/login') && !url.includes('/auth/register')) {
      // Token likely invalid/expired — wipe it
      authStorage.clear();
    }
    return Promise.reject(error);
  }
);
